import React, { useContext } from 'react';

import { Skeleton } from '@material-ui/lab';
import tw, { styled } from 'twin.macro';

import { InfiniteScroll } from '@/components/InfiniteScroll';
import { UserListFilters } from '@/core/users/UserManagement/UserListFilters';
import { UserListHeader } from '@/core/users/UserManagement/UserListHeader';
import { UserRow } from '@/core/users/UserManagement/UserRow';
import { UserSearchContext } from '@/core/users/UserManagement/UserSearchContext';

const ROW_HEIGHT = '70px';

export function UserList () {
  const {
    emailFilter,
    error,
    fetchMoreIfReady,
    hasMore,
    isInitialLoad,
    loading,
    setEmailFilter,
    users,
  } = useContext(UserSearchContext);

  return (
    <>
      <UserListFilters
        email={emailFilter}
        onEmailChange={(email) => setEmailFilter(email)}
      />
      <StyledTable
        className={`w-full text-gray-800 border-separate table-fixed ${!isInitialLoad && loading && !users ? 'opacity-50' : ''}`}
        cellPadding={0}
      >
        <tbody>
          <UserListHeader />
          {users && (
            <>
              {users?.map((user) => (
                <UserRow key={user.id} user={user} preventMotion={loading} />
              ))}
            </>
          )}
        </tbody>
      </StyledTable>
      {(emailFilter && users?.length === 0) && (
        <div className="flex items-center px-6 py-4 text-sm text-gray-600 bg-gray-100 rounded">
          <span className="flex items-center justify-center float-left w-10 h-10 font-bold bg-white rounded-full">?</span>
          <span className="m-auto">
            Nothing to see here.
            <button
              className="p-2 underline"
              onClick={() => setEmailFilter('')}
            >
              Clear results
            </button>
          </span>
        </div>
      )}
      {(isInitialLoad || loading || error) && <LoadingRowSkeletons />}
      {hasMore && (
        <InfiniteScroll onScrollOver={fetchMoreIfReady} />
      )}
    </>
  );
}

function LoadingRowSkeletons () {
  return (
    <>
      {[...Array(10)].map((_, index) => (
        <Skeleton key={`loading-row-${index}`} variant="rect" className="w-full mb-4" style={{ height: ROW_HEIGHT }} />
      ))}
    </>
  );
}

const StyledTable = styled.table`
  & th, a {
    ${tw`px-6 py-4`}
  }
  & td > * {
    ${tw`bg-gray-100`}
    height: ${ROW_HEIGHT};
  }
  border-spacing: 0 .75rem;
`;
